import type { Metadata } from "next";

/** One normalized origin for canonical URLs, feeds, sitemaps and schema IDs. */
export function siteUrl(path = "/"): string {
    const configured = process.env.NEXT_PUBLIC_WEBSITE_URL;
    if (!configured) throw new Error("NEXT_PUBLIC_WEBSITE_URL is required for SEO URLs.");
    const origin = new URL(configured);
    if (!/^https?:$/.test(origin.protocol)) throw new Error("The website URL must use HTTP or HTTPS.");
    return new URL(path, origin.origin).href;
}

export const INDEXABLE_ROBOTS: Metadata["robots"] = {
    index: true,
    follow: true,
    "max-image-preview": "large",
    "max-snippet": -1,
    "max-video-preview": -1,
};

export function jsonLd(value: unknown): string {
    return JSON.stringify(value).replace(/</g, "\\u003c");
}

/** Avoid truncated words and markup in search snippets. */
export function seoDescription(value: string, limit = 160): string {
    const text = value.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    if (text.length <= limit) return text;
    const clipped = text.slice(0, limit - 1);
    const boundary = clipped.lastIndexOf(" ");
    return `${boundary > 0 ? clipped.slice(0, boundary) : clipped}…`;
}
